import { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import {
	DimGrunnlagContext,
	DimGrunnlagContextTypeValues,
} from '../context/DimGrunnlagContext.tsx';
import { useRouter } from 'next/router';
import { Urls } from '../Urls.ts';
import styled from 'styled-components';
import LoaderWrapper from '../../components/atoms/loading/LoaderWrapper.tsx';

interface DimGrunnlagProviderProps {
	children: ReactNode;
}

/**
 * loading er brukt til å si ifra om values av type {DimGrunnlagContextTypeValues} har blitt lastet inn fra sessionStorage </br>
 * Rett og slett for å unngå at useEffect-en som bruker values trigger hele tiden. </br>
 * @param children
 * @constructor
 */
export const DimGrunnlagProvider: FC<DimGrunnlagProviderProps> = ({ children }) => {
	const sessionStorageKey = 'dimGrunnlag';
	const router = useRouter();
	const [loading, setLoading] = useState(true);
	const [values, setValues] = useState<DimGrunnlagContextTypeValues>({});
	const updateValues = useCallback((newValues: DimGrunnlagContextTypeValues) => {
		setValues((oldValues) => ({ ...oldValues, ...newValues }));
	}, []);
	useEffect(() => {
		if (Object.keys(values).length > 0) {
			sessionStorage.setItem(sessionStorageKey, JSON.stringify(values));
		}
	}, [values]);
	useEffect(() => {
		const data = sessionStorage.getItem(sessionStorageKey);
		const isOnDimensjoneringsPage =
			router.pathname === Urls.mekanistiskEmpiriskDimensjonering ||
			router.pathname === Urls.dimensjonering;
		if (data && Object.keys(data).length > 2) {
			const newValues: DimGrunnlagContextTypeValues = JSON.parse(data);
			setValues(newValues);
		} else if (Object.keys(values).length === 0 && isOnDimensjoneringsPage) {
			setLoading(true);
			router.push(Urls.velgdimensjoneringsmetode).then(() => setLoading(false));
		}
		setLoading(false);
		// eslint-disable-next-line
	}, []);

	return (
		<DimGrunnlagContext.Provider
			value={{
				values,
				updateValues,
				loading,
			}}
		>
			<StyledLoaderWrapper loading={loading} description='Laster inn...'>
				{children}
			</StyledLoaderWrapper>
		</DimGrunnlagContext.Provider>
	);
};

const StyledLoaderWrapper = styled(LoaderWrapper)`
	height: 100dvh;
`;
